export const GOAL_STATUS_OPTIONS = [
  { value: "not_started", label: "Not started" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
];

const LEGACY_STATUS_MAP = {
  draft: "not_started",
  active: "in_progress",
  cancelled: "completed",
};

export function normalizeGoalStatus(status) {
  if (!status) return "not_started";
  return LEGACY_STATUS_MAP[status] || status;
}

export function goalStatusLabel(status) {
  const normalized = normalizeGoalStatus(status);
  const option = GOAL_STATUS_OPTIONS.find((item) => item.value === normalized);
  return option?.label || normalized.replaceAll("_", " ");
}

export function goalStatusColor(status) {
  const normalized = normalizeGoalStatus(status);
  const map = {
    not_started: "bg-gray-100 text-gray-700 border border-gray-200",
    in_progress: "bg-primary/10 text-primary border border-primary/20",
    completed: "bg-green-100 text-green-700 border border-green-200",
  };
  return map[normalized] || map.not_started;
}

export function stripHtml(html) {
  if (!html) return "";
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
